import React from 'react';
import './Resources.css';

const Resources = () => {
  return (
    <div className="resources-container">
        <h1>RESOURCES AROUND THE CAMPUS</h1>

        <div className="section pointsr reverse-layout">
          <div className="text-boxr">
            <h2>Qualifier Exam Information</h2>
            <p>
            Find information that will help you prepare well for Qualifier Exams.
            </p>
            <p>
              <a href="/qualifier" className="explore-events-btnr">Link to Resources</a>
            </p>
          </div>
          <div className="photo-boxr">
            <img src={`${process.env.PUBLIC_URL}/images/resources/1.png`} alt="Logo"/>
          </div>
        </div>

        <div className="section pointsr">
          <div className="photo-boxr">
            <img src={`${process.env.PUBLIC_URL}/images/resources/2.png`} alt="Logo"/>
          </div>
          <div className="text-boxr">
            <h2>Grants & Fellowships</h2>
            <p>
            Apply for grants or fellowships at link below.
            </p>
            <p>
              <a href="https://www.utdallas.edu/nsm/scholarships" className="explore-events-btnr">Link</a>
            </p>
          </div>
        </div>

        <div className="section pointsr reverse-layout">
          <div className="text-boxr">
            <h2>Library</h2>
            <p>
            The library has access to academic
            journals on/off campus. Just sign in
            on the library page.
            </p>
            <p>
              <a href="https://library.utdallas.edu/" className="explore-events-btnr">Explore</a>
            </p>
          </div>
          <div className="photo-boxr">
            <img src={`${process.env.PUBLIC_URL}/images/resources/3.png`} alt="Logo"/>
          </div>
        </div>

        <div className="section pointsr">
          <div className="photo-boxr">
            <img src={`${process.env.PUBLIC_URL}/images/resources/4.png`} alt="Logo"/>
          </div>
          <div className="text-boxr">
            <h2>Comet Cupboard</h2>
            <p>
            The Comet cupboard below library
            offers free grocery items to students
            once every week.
            </p>
            <p>
            Sprit Fridays at Dining Hall West –
            wear orange/green UTD clothes for
            a $6 lunch.
            </p>
          </div>
        </div>

        <div className="section pointsr reverse-layout">
          <div className="text-boxr">
            <h2>Other Free Resources</h2>
            <p>
            Free software licenses for MATLAB, Overleaf, Mathematica, Office 365 (Drive, pptx, Excel,…)
            </p>
            <p>
            Free stationary available at SCI 3.237.
            </p>
            <p>
              <a href="https://map.utdallas.edu/" className="explore-events-btnr">Link to Campus Map</a>
            </p>
          </div>
          <div className="photo-boxr">
            <img src={`${process.env.PUBLIC_URL}/images/resources/5.png`} alt="Logo"/>
          </div>
        </div>

        <h1>ADVICE FROM GSP</h1>
        <div className="section pointsr reverse-layout">
          <div className="text-boxr">
            <div>
              <p>Stay on schedule for your program.</p>
              <p>Take the quals very seriously! Make use of the resources we have.</p>
              <p>Meet new people! Talk to others that aren’t in your field. The bowling event is a great start. </p>
              <p>Find a work/social life balance that works for you.</p>
            </div>
          </div>
          <div className="photo-boxr">
            <img src={`${process.env.PUBLIC_URL}/images/resources/7.png`} alt="Logo"/>
          </div>
        </div>

      </div>
  );
};

export default Resources;
